import { render, staticRenderFns } from "./DepchineseForm.vue?vue&type=template&id=2b20d2dd&scoped=true&"
import script from "./DepchineseForm.vue?vue&type=script&lang=js&"
export * from "./DepchineseForm.vue?vue&type=script&lang=js&"
import style0 from "./DepchineseForm.vue?vue&type=style&index=0&id=2b20d2dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b20d2dd",
  null
  
)

export default component.exports